// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ISiteRegistrationRequestModel {
    static getAttributeTypeMap() {
        return ISiteRegistrationRequestModel.attributeTypeMap;
    }
}
ISiteRegistrationRequestModel.discriminator = undefined;
ISiteRegistrationRequestModel.additionalProperties = false;
ISiteRegistrationRequestModel.attributeTypeMap = [
    {
        "name": "userName",
        "baseName": "userName",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "ScriptsSiteAccountSiteRegistrationISiteRegistrationUserContactInfoRequestModel"
    },
    {
        "name": "fax",
        "baseName": "fax",
        "type": "ScriptsSiteAccountSiteRegistrationISiteRegistrationUserContactInfoRequestModel"
    },
    {
        "name": "email",
        "baseName": "email",
        "type": "ScriptsSiteAccountSiteRegistrationISiteRegistrationUserContactInfoRequestModel"
    },
    {
        "name": "siteAccountUpsearch",
        "baseName": "siteAccountUpsearch",
        "type": "EnterpriseCoordinatorSiteAccountUpsearchRequestModel"
    },
];
//# sourceMappingURL=iSiteRegistrationRequestModel.js.map